import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { TableBody as TableBodyBase } from 'prime-ng-old/table';
import { TableService } from './service';
import { PARENT_TABLE, PARENT_TABLE_BODY } from './table.injection-token';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'prime-ng-old/inputnumber';
import { ScrollerModule } from 'prime-ng-old/scroller';
import * as i0 from "@angular/core";
import * as i1 from "./service";
import * as i2 from "@angular/common";
const _c0 = ["pTableBody", ""];
const _c1 = (a0, a1, a2, a3, a4) => ({
  $implicit: a0,
  rowIndex: a1,
  columns: a2,
  editing: a3,
  frozen: a4
});
const _c2 = (a0, a1, a2, a3, a4, a5, a6) => ({
  $implicit: a0,
  rowIndex: a1,
  columns: a2,
  editing: a3,
  frozen: a4,
  rowgroup: a5,
  rowspan: a6
});
const _c3 = (a0, a1, a2, a3, a4, a5) => ({
  $implicit: a0,
  rowIndex: a1,
  columns: a2,
  expanded: a3,
  editing: a4,
  frozen: a5
});
const _c4 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  rowIndex: a1,
  columns: a2,
  frozen: a3
});
const _c5 = (a0, a1) => ({
  $implicit: a0,
  frozen: a1
});
function _forTrack0($index, $item) {
  return this.dt.rowTrackBy($index, $item);
}
function TableBody_Conditional_0_For_1_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_0_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 0);
    i0.ɵɵtemplate(1, TableBody_Conditional_0_For_1_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const rowData_r2 = ctx_r0.$implicit;
    const ɵ$index_2_r3 = ctx_r0.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.groupHeaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c1, rowData_r2, ctx_r3.getRowIndex(ɵ$index_2_r3), ctx_r3.columns, ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r2), ctx_r3.frozen));
  }
}
function TableBody_Conditional_0_For_1_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_0_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_Conditional_0_For_1_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const rowData_r2 = ctx_r0.$implicit;
    const ɵ$index_2_r3 = ctx_r0.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", rowData_r2 ? ctx_r3.template : ctx_r3.dt.loadingBodyTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c1, rowData_r2, ctx_r3.getRowIndex(ɵ$index_2_r3), ctx_r3.columns, ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r2), ctx_r3.frozen));
  }
}
function TableBody_Conditional_0_For_1_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_0_For_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_Conditional_0_For_1_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const rowData_r2 = ctx_r0.$implicit;
    const ɵ$index_2_r3 = ctx_r0.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", rowData_r2 ? ctx_r3.template : ctx_r3.dt.loadingBodyTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction7(2, _c2, rowData_r2, ctx_r3.getRowIndex(ɵ$index_2_r3), ctx_r3.columns, ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r2), ctx_r3.frozen, ctx_r3.shouldRenderRowspan(ctx_r3.value, rowData_r2, ɵ$index_2_r3), ctx_r3.calculateRowGroupSize(ctx_r3.value, rowData_r2, ɵ$index_2_r3)));
  }
}
function TableBody_Conditional_0_For_1_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_0_For_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 0);
    i0.ɵɵtemplate(1, TableBody_Conditional_0_For_1_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const rowData_r2 = ctx_r0.$implicit;
    const ɵ$index_2_r3 = ctx_r0.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.groupFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c1, rowData_r2, ctx_r3.getRowIndex(ɵ$index_2_r3), ctx_r3.columns, ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r2), ctx_r3.frozen));
  }
}
function TableBody_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, TableBody_Conditional_0_For_1_Conditional_0_Template, 2, 8, "ng-container", 0);
    i0.ɵɵconditionalCreate(1, TableBody_Conditional_0_For_1_Conditional_1_Template, 1, 8, "ng-container");
    i0.ɵɵconditionalCreate(2, TableBody_Conditional_0_For_1_Conditional_2_Template, 1, 10, "ng-container");
    i0.ɵɵconditionalCreate(3, TableBody_Conditional_0_For_1_Conditional_3_Template, 2, 8, "ng-container", 0);
  }
  if (rf & 2) {
    const rowData_r2 = ctx.$implicit;
    const ɵ$index_2_r3 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r3.dt.groupHeaderTemplate && !ctx_r3.dt.virtualScroll && ctx_r3.dt.rowGroupMode === "subheader" && ctx_r3.shouldRenderRowGroupHeader(ctx_r3.value, rowData_r2, ɵ$index_2_r3) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.dt.rowGroupMode !== "rowspan" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.dt.rowGroupMode === "rowspan" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.dt.groupFooterTemplate && !ctx_r3.dt.virtualScroll && ctx_r3.dt.rowGroupMode === "subheader" && ctx_r3.shouldRenderRowGroupFooter(ctx_r3.value, rowData_r2, ɵ$index_2_r3) ? 3 : -1);
  }
}
function TableBody_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, TableBody_Conditional_0_For_1_Template, 4, 4, null, null, _forTrack0, true);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r3.value);
  }
}
function TableBody_Conditional_1_For_1_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_1_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_Conditional_1_For_1_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const rowData_r6 = ctx_r4.$implicit;
    const ɵ$index_28_r7 = ctx_r4.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.template)("ngTemplateOutletContext", i0.ɵɵpureFunction6(2, _c3, rowData_r6, ctx_r3.getRowIndex(ɵ$index_28_r7), ctx_r3.columns, ctx_r3.dt.isRowExpanded(rowData_r6), ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r6), ctx_r3.frozen));
  }
}
function TableBody_Conditional_1_For_1_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_1_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 0);
    i0.ɵɵtemplate(1, TableBody_Conditional_1_For_1_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const rowData_r6 = ctx_r4.$implicit;
    const ɵ$index_28_r7 = ctx_r4.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.groupHeaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction6(2, _c3, rowData_r6, ctx_r3.getRowIndex(ɵ$index_28_r7), ctx_r3.columns, ctx_r3.dt.isRowExpanded(rowData_r6), ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r6), ctx_r3.frozen));
  }
}
function TableBody_Conditional_1_For_1_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_1_For_1_Conditional_2_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_1_For_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 0);
    i0.ɵɵtemplate(1, TableBody_Conditional_1_For_1_Conditional_2_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const rowData_r6 = ctx_r4.$implicit;
    const ɵ$index_28_r7 = ctx_r4.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.groupFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction6(2, _c3, rowData_r6, ctx_r3.getRowIndex(ɵ$index_28_r7), ctx_r3.columns, ctx_r3.dt.isRowExpanded(rowData_r6), ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r6), ctx_r3.frozen));
  }
}
function TableBody_Conditional_1_For_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_Conditional_1_For_1_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 1);
    i0.ɵɵconditionalCreate(1, TableBody_Conditional_1_For_1_Conditional_2_Conditional_1_Template, 2, 9, "ng-container", 0);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const rowData_r6 = ctx_r4.$implicit;
    const ɵ$index_28_r7 = ctx_r4.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.expandedRowTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(3, _c4, rowData_r6, ctx_r3.getRowIndex(ɵ$index_28_r7), ctx_r3.columns, ctx_r3.frozen));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.dt.groupFooterTemplate && ctx_r3.dt.rowGroupMode === "subheader" && ctx_r3.shouldRenderRowGroupFooter(ctx_r3.value, rowData_r6, ctx_r3.getRowIndex(ɵ$index_28_r7)) ? 1 : -1);
  }
}
function TableBody_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, TableBody_Conditional_1_For_1_Conditional_0_Template, 1, 9, "ng-container");
    i0.ɵɵconditionalCreate(1, TableBody_Conditional_1_For_1_Conditional_1_Template, 2, 9, "ng-container", 0);
    i0.ɵɵconditionalCreate(2, TableBody_Conditional_1_For_1_Conditional_2_Template, 2, 8);
  }
  if (rf & 2) {
    const rowData_r6 = ctx.$implicit;
    const ɵ$index_28_r7 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r3.dt.groupHeaderTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.dt.groupHeaderTemplate && ctx_r3.dt.rowGroupMode === "subheader" && ctx_r3.shouldRenderRowGroupHeader(ctx_r3.value, rowData_r6, ctx_r3.getRowIndex(ɵ$index_28_r7)) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.dt.isRowExpanded(rowData_r6) ? 2 : -1);
  }
}
function TableBody_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, TableBody_Conditional_1_For_1_Template, 3, 3, null, null, _forTrack0, true);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r3.value);
  }
}
function TableBody_Conditional_2_For_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_2_For_1_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_2_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_Conditional_2_For_1_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const rowData_r9 = ctx_r7.$implicit;
    const ɵ$index_54_r10 = ctx_r7.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.frozenExpandedRowTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c4, rowData_r9, ctx_r3.getRowIndex(ɵ$index_54_r10), ctx_r3.columns, ctx_r3.frozen));
  }
}
function TableBody_Conditional_2_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_Conditional_2_For_1_ng_container_0_Template, 1, 0, "ng-container", 1);
    i0.ɵɵconditionalCreate(1, TableBody_Conditional_2_For_1_Conditional_1_Template, 1, 7, "ng-container");
  }
  if (rf & 2) {
    const rowData_r9 = ctx.$implicit;
    const ɵ$index_54_r10 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.template)("ngTemplateOutletContext", i0.ɵɵpureFunction6(3, _c3, rowData_r9, ctx_r3.getRowIndex(ɵ$index_54_r10), ctx_r3.columns, ctx_r3.dt.isRowExpanded(rowData_r9), ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r9), ctx_r3.frozen));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.dt.isRowExpanded(rowData_r9) ? 1 : -1);
  }
}
function TableBody_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, TableBody_Conditional_2_For_1_Template, 2, 10, null, null, _forTrack0, true);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r3.value);
  }
}
function TableBody_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.loadingBodyTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c5, ctx_r3.columns, ctx_r3.frozen));
  }
}
function TableBody_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.emptyMessageTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c5, ctx_r3.columns, ctx_r3.frozen));
  }
}
export let TableBody = /*#__PURE__*/(() => {
  class TableBody extends TableBodyBase {
    constructor(dt, tableService, cd, el) {
      super(dt, tableService, cd, el);
      this.dt = dt;
      this.tableService = tableService;
      this.cd = cd;
      this.el = el;
    }
    static {
      this.ɵfac = function TableBody_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TableBody)(i0.ɵɵdirectiveInject(PARENT_TABLE), i0.ɵɵdirectiveInject(i1.TableService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: TableBody,
        selectors: [["", "pTableBody", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: PARENT_TABLE_BODY,
          useExisting: TableBody
        }]), i0.ɵɵInheritDefinitionFeature],
        attrs: _c0,
        decls: 5,
        vars: 5,
        consts: [["role", "row"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function TableBody_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, TableBody_Conditional_0_Template, 2, 0);
            i0.ɵɵconditionalCreate(1, TableBody_Conditional_1_Template, 2, 0);
            i0.ɵɵconditionalCreate(2, TableBody_Conditional_2_Template, 2, 0);
            i0.ɵɵconditionalCreate(3, TableBody_Conditional_3_Template, 1, 5, "ng-container");
            i0.ɵɵconditionalCreate(4, TableBody_Conditional_4_Template, 1, 5, "ng-container");
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.dt.expandedRowTemplate ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.dt.expandedRowTemplate && !(ctx.frozen && ctx.dt.frozenExpandedRowTemplate) ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.dt.frozenExpandedRowTemplate && ctx.frozen ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.dt.loading ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.dt.isEmpty() && !ctx.dt.loading ? 4 : -1);
          }
        },
        dependencies: [CommonModule, i2.NgTemplateOutlet, ScrollerModule, FormsModule,
        // TODO: these are direct primeNG imports because these components are not being used anywhere else. Should be updated if customized ui versions are being created.
        InputNumberModule],
        encapsulation: 2
      });
    }
  }
  return TableBody;
})();